import { Component, Input, output } from '@angular/core';

import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'rt-chips',
  templateUrl: './chips.component.html',
  styleUrls: ['./chips.component.less'],
  imports: [IconComponent],
})
export class ChipsComponent {
  @Input({ required: true }) public text: string;
  @Input() public showClose: boolean = true;

  public close = output<void>();
}
